import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";

import { KeyUnprotect } from "../../../routes/cryptography";

import FileDownload from "js-file-download";
import { Buffer } from "buffer"

class KeyUnprotectView extends Component {
  constructor() {
    super();
    this.state = {
      dataKeyUnprotect: {
        dataPrivKey: "",
        password: "",
      },
      privkeyFileName: "файл",
      privkeyFileIsOpen: false,
    };
    this.handleInputPassChange = this.handleInputPassChange.bind(this);
    this.handlePrivKeyChange = this.handlePrivKeyChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleInputPassChange(e) {
    //console.log(e.target.value);
    try {
      this.setState({
        dataKeyUnprotect: {
          ...this.state.dataKeyUnprotect,
          password: e.target.value,
        },
      });

      ////console.log(e.target.value);
    } catch (error) {
      //console.log(error);
    }
  }
  handlePrivKeyChange() {
    try {
      const file = document.getElementById("filePrivkey").files[0];
      //console.log(file);

      if (file !== undefined) {
        this.setState({ privkeyFileName: file.name, privkeyFileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer)).toString("base64");

          this.setState({
            dataKeyUnprotect: {
              ...this.state.dataKeyUnprotect,
              dataPrivKey: data,
            },
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ privkeyFileName: "файл", privkeyFileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }
  handleSubmit(e) {
    try {
      e.preventDefault();
      KeyUnprotect(
        this.state.dataKeyUnprotect.dataPrivKey,
        btoa(unescape(encodeURIComponent(this.state.dataKeyUnprotect.password)))
      ).then((result) => {
        try {
          //console.log(result);
          if (result.status === 200) {
            FileDownload(
              new Buffer.from(result.data.privKey, "base64").toString(),
              "keyunprotect.pem"
            );
            document.getElementById("view").style.borderColor = "green";
          } else {
            document.getElementById("view").style.borderColor = "red";

            this.setState({
              statusGenPrivKey: "Ошибка",
            });
          }
        } catch (error) {
          //console.log(error);
          document.getElementById("view").style.borderColor = "red";

          this.setState({
            statusGenPrivKey: "Ошибка",
          });
        }
      });
    } catch (error) {
      //console.log(error);
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div className="container ">
        <h6 className="major" style={{ marginRight: "20px" }}>
          Cнятие защиты с личного ключа
        </h6>
        <Form onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.Label>Выберите защищенный токен личного ключа</Form.Label>
            <Form.File custom>
              <Form.File.Input
                id="filePrivkey"
                onChange={this.handlePrivKeyChange}
                isValid={this.state.privkeyFileIsOpen}
                required
              />
              <Form.File.Label data-browse="Выбрать">
                {this.state.privkeyFileName}
              </Form.File.Label>
              <Form.Control.Feedback type="valid" />
            </Form.File>
          </Form.Group>
          <Form.Group>
            <Form.Label>Введите пароль для снятия защиты</Form.Label>
            <Form.Control
              type="password"
              placeholder="Пароль"
              onChange={this.handleInputPassChange}
              style={{ height: "2rem", color:"white" }}
              required
            />
          </Form.Group>
          <div className="sm-4 ">
            <Button
              type="submit"
              size="sm"
              style={{ float: "right" }}
            >
              Сгенерировать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(KeyUnprotectView));
